export default function EnquiriesPage(){
    return (
        <div className="text-light">
            <h1 className="h3 fw-bold mb-3">Events</h1>
            <div className="card admin-card">
                <div className="card-body p-4">
                    <p className="text-white-50 mb-0">
                        Enquiries management page will be implemented next.
                    </p>
                </div>
            </div>
        </div>
    );

}